(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benditos-header"]) return;
  try {
    
if (!customElements.get('btb-site-header')) {
  customElements.define('btb-site-header', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionButton = this.querySelector('.btb2-motion');
      this.progress = this.querySelector('.btb2-reading-progress');
      this.menu = this.querySelector('.btb2-menu');
      this.revealObserver?.disconnect();
      this.revealed = new WeakSet();
      this.preference = null;
      try { this.preference = localStorage.getItem('btb-motion'); } catch {}
      this.applyMotion = () => {
        this.paused = this.motionQuery.matches || this.preference === 'paused';
        document.documentElement.classList.toggle('btb2-motion-paused', this.paused);
        this.motionButton.hidden = this.motionQuery.matches;
        this.motionButton.setAttribute('aria-pressed', String(this.paused));
        this.motionButton.querySelector('[data-motion-label]').textContent = this.paused ? this.motionButton.dataset.motionResume : this.motionButton.dataset.motionPause;
        this.motionButton.firstElementChild.innerHTML = this.paused ? "<svg class=\"btb2-icon\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"m8 4 12 8-12 8Z\"/></svg>" : "<svg class=\"btb2-icon\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M8 5v14M16 5v14\"/></svg>";
        if (this.paused) document.querySelectorAll('.btb2-home, .btb-page').forEach(root => root.getAnimations({subtree:true}).forEach(animation => {
          if (animation instanceof CSSAnimation) animation.pause();
          else animation.finish();
        }));
        else document.querySelectorAll('.btb2-home').forEach(root => root.getAnimations({subtree:true}).forEach(animation => {
          if (animation instanceof CSSAnimation) animation.play();
        }));
        document.dispatchEvent(new CustomEvent('btb:motion', {detail:{paused:this.paused}}));
      };
      this.motionButton.addEventListener('click', () => {
        this.preference = this.paused ? 'playing' : 'paused';
        try { localStorage.setItem('btb-motion', this.preference); } catch {}
        this.applyMotion();
      }, {signal});
      this.motionQuery.addEventListener('change', this.applyMotion, {signal});
      this.applyMotion();
      this.closeMenu = (focus = false) => {
        if (!this.menu.open) return;
        this.menu.open = false;
        if (focus) this.menu.querySelector('summary').focus();
      };
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.closeMenu(true); }, {signal});
      document.addEventListener('click', event => {
        if (!this.menu.contains(event.target)) this.closeMenu();
        else if (event.target.closest('a')) this.closeMenu();
      }, {signal});
      document.addEventListener('focusin', event => { if (!this.menu.contains(event.target)) this.closeMenu(); }, {signal});
      this.desktopQuery = matchMedia('(min-width: 901px)');
      this.desktopQuery.addEventListener('change', event => { if (event.matches) this.closeMenu(); }, {signal});
      this.querySelectorAll('nav a').forEach(link => {
        if (new URL(link.href).pathname.replace(/\/$/,'') === location.pathname.replace(/\/$/,'')) link.setAttribute('aria-current', 'page');
      });
      this.renderProgress = () => {
        this.frame = null;
        const total = document.documentElement.scrollHeight - innerHeight;
        this.progress.style.transform = 'scaleX(' + (total > 0 ? Math.min(1, Math.max(0, scrollY / total)) : 0) + ')';
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(this.renderProgress); };
      window.addEventListener('scroll', schedule, {signal, passive:true});
      window.addEventListener('resize', schedule, {signal, passive:true});
      this.sizeObserver = new ResizeObserver(schedule);
      this.sizeObserver.observe(document.body);
      this.renderProgress();
      if ('IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const element = entry.target;
            this.revealObserver.unobserve(element);
            if (this.paused || document.hidden || window.Shopify?.designMode) return;
            const index = Array.from(element.parentElement.children).indexOf(element);
            element.animate([{opacity:0,transform:'translateY(28px)'},{opacity:1,transform:'translateY(0)'}], {
              duration:850, delay:Math.min(index,3)*60, easing:'cubic-bezier(.22,1,.36,1)', fill:'backwards'
            });
          });
        }, {threshold:.08});
        this.scan = () => {
          document.querySelectorAll('[data-reveal], .btb-page-hero, .btb-page-card, .btb-page-step, .btb-page-band').forEach(element => {
            if (!this.revealed.has(element)) { this.revealed.add(element); this.revealObserver.observe(element); }
          });
        };
        this.scan();
        document.addEventListener('shopify:section:load', this.scan, {signal});
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.scan, {signal,once:true});
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.revealObserver?.disconnect();
      this.sizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benditos-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('btb-giving')) {
  customElements.define('btb-giving', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.trigger = this.querySelector('.btb2-giving-trigger');
      this.seed = this.querySelector('.btb2-giving-seed');
      this.visible = !('IntersectionObserver' in window);
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.isPaused = () => this.reduced.matches || document.documentElement.classList.contains('btb2-motion-paused');
      this.sync = () => {
        const running = this.visible && !document.hidden && !this.isPaused() && !window.Shopify?.designMode;
        this.dataset.running = String(running);
        this.trigger.hidden = this.isPaused();
        this.getAnimations({subtree:true}).forEach(animation => {
          if (animation instanceof CSSAnimation) running ? animation.play() : animation.pause();
        });
        if (!running) { this.tapAnimation?.cancel(); this.seedAnimation?.cancel(); }
      };
      this.trigger.addEventListener('click', () => {
        if (this.dataset.running !== 'true') return;
        this.tapAnimation?.cancel();
        this.seedAnimation?.cancel();
        this.querySelectorAll('.btb2-giving-flow, .btb2-giving-node').forEach(element => {
          element.getAnimations().forEach(animation => { animation.currentTime = 0; });
        });
        this.tapAnimation = this.querySelector('.btb2-giving-tap').animate(
          [{opacity:.75,transform:'scale(.04)'},{opacity:0,transform:'scale(1.08)'}],
          {duration:2400,easing:'cubic-bezier(.16,1,.3,1)'}
        );
        this.seedAnimation = this.seed.animate(
          [{scale:1},{scale:.88,offset:.15},{scale:1.08,offset:.45},{scale:1}],
          {duration:900,easing:'ease-out'}
        );
      }, {signal});
      document.addEventListener('visibilitychange', this.sync, {signal});
      document.addEventListener('btb:motion', this.sync, {signal});
      this.reduced.addEventListener('change', this.sync, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.sync();
        }, {threshold:.1});
        this.observer.observe(this);
      }
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.tapAnimation?.cancel();
      this.seedAnimation?.cancel();
      this.dataset.running = 'false';
    }
  });
}
if (!customElements.get('btb-home')) {
  customElements.define('btb-home', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.controls = this.querySelector('.btb2-cause-controls');
      this.buttons = [...this.querySelectorAll('[data-cause]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.artwork = this.querySelector('[data-parallax]');
      this.active = 0;
      this.isPaused = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('btb2-motion-paused');
      this.selectCause = (index, animate = true) => {
        if (!Number.isInteger(index) || index < 0 || index >= this.panels.length) return;
        this.panelAnimation?.cancel();
        this.active = index;
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        if (animate && !this.isPaused()) {
          this.panelAnimation = this.panels[index].animate([{opacity:.3,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'cubic-bezier(.22,1,.36,1)'});
        }
      };
      this.controls.hidden = false;
      this.selectCause(0, false);
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('[data-cause]');
        if (button) this.selectCause(Number(button.dataset.cause));
      }, {signal});
      this.controls.addEventListener('keydown', event => {
        const current = this.buttons.indexOf(event.target);
        if (current < 0) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.buttons.length) % this.buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.buttons[next].focus();
        this.selectCause(next);
      }, {signal});
      this.querySelectorAll('[data-cause-jump]').forEach(link => link.addEventListener('click', () => {
        this.selectCause(Number(link.dataset.causeJump));
      }, {signal}));
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      const hero = this.querySelector('.btb2-hero');
      const resetArtwork = () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.artwork.style.setProperty('--shift-x','0px');
        this.artwork.style.setProperty('--shift-y','0px');
      };
      hero.addEventListener('pointermove', event => {
        if (!this.finePointer.matches || this.isPaused()) return;
        this.pointer = {x:event.clientX,y:event.clientY};
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const bounds = hero.getBoundingClientRect();
          this.artwork.style.setProperty('--shift-x', ((this.pointer.x - bounds.left) / bounds.width - .5) * 20 + 'px');
          this.artwork.style.setProperty('--shift-y', ((this.pointer.y - bounds.top) / bounds.height - .5) * 16 + 'px');
        });
      }, {signal, passive:true});
      hero.addEventListener('pointerleave',resetArtwork,{signal});
      document.addEventListener('btb:motion', event => {
        if (event.detail.paused) { resetArtwork(); this.panelAnimation?.finish(); }
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        this.style.setProperty('--btb-animation-state', document.hidden ? 'paused' : 'running');
      }, {signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.panelAnimation?.cancel();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
if (!customElements.get('btb-quote-rotator')) {
  customElements.define('btb-quote-rotator', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-quote]')];
      this.controls = this.querySelector('.btb2-quote-controls');
      this.slideGroup = this.querySelector('.btb2-quote-slides');
      this.index = 0;
      this.focused = false;
      this.visible = !('IntersectionObserver' in window);
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.globalPaused = () => this.reduced.matches || document.documentElement.classList.contains('btb2-motion-paused');
      this.stop = () => { clearTimeout(this.timer); this.timer = null; };
      this.schedule = () => {
        this.stop();
        if (this.globalPaused() || this.focused || !this.visible || document.hidden || window.Shopify?.designMode) return;
        const words = this.slides[this.index].querySelector('blockquote').textContent.trim().split(/\s+/).length;
        this.timer = setTimeout(() => { this.show(this.index + 1); }, Math.max(8500, words * 320 + 1800));
      };
      this.show = (index, manual = false) => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slideGroup.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.dataset.active = String(active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.schedule();
      };
      this.sync = () => this.schedule();
      this.querySelector('[data-quote-prev]').addEventListener('click', () => this.show(this.index - 1, true), {signal});
      this.querySelector('[data-quote-next]').addEventListener('click', () => this.show(this.index + 1, true), {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, {signal});
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, {signal});
      this.controls.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, {signal});
      document.addEventListener('visibilitychange', this.schedule, {signal});
      document.addEventListener('btb:motion', this.sync, {signal});
      this.reduced.addEventListener('change', this.sync, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.schedule();
        }, {threshold:.2});
        this.observer.observe(this);
      }
      this.classList.add('btb2-quotes-enhanced');
      this.controls.hidden = false;
      this.show(0);
      this.sync();
    }
    disconnectedCallback() {
      this.stop?.();
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
